module.exports = __webpack_public_path__ + "static/img/当心感染.7cfc3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/当心感染.png
// module id = Y/p1
// module chunks = 1